import { VirtualCardType } from './constants'

/**
 * Maps benefit/application wire values to VirtualCardType.
 * Absent or unknown values default to Marqeta.
 */
export function normalizeVcnProvider(raw: unknown): VirtualCardType {
  if (raw == null || raw === '') {
    return VirtualCardType.MARQETA
  }
  const normalized = String(raw).trim().toLowerCase()
  if (normalized === 'wex') {
    return VirtualCardType.WEX
  }
  if (normalized === 'marqeta') {
    return VirtualCardType.MARQETA
  }
  return VirtualCardType.MARQETA
}
